<!-- DisenosTabla.vue — Tabla de preaprobaciones de diseño -->
<!-- Diseño calcado de CrudTpus.vue para que la sección no desentone -->
<!-- Emits: ver-pdfs, ver-detalle, editar, eliminar, cambiar-pagina, update:sort, cambiar-por-pagina -->
<template>
  <div>
    <!-- TABLA ESCRITORIO -->
    <!-- Umbral en xl (1200px), no lg (992px): con 7 columnas la tabla ya no
         cabía a 1024px y la fecha de creación se salía sin scroll visible. -->
    <div class="divisan-table-container shadow-lg d-none d-xl-block">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>

      <table v-else class="table table-divisan align-middle mb-0">
        <thead>
          <tr>
            <th class="ps-4">
              <ColumnFilterMenu
                field="cotizacion"
                label="Cotización"
                :filterable="false"
                :items="disenos"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="(e) => $emit('update:sort', e)"
              />
            </th>
            <th>
              <ColumnFilterMenu
                field="cliente"
                label="Cliente"
                :filterable="false"
                :items="disenos"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="(e) => $emit('update:sort', e)"
              />
            </th>
            <th class="text-center">Estatus</th>
            <th class="text-center">WhatsApp</th>
            <th class="text-center col-doc">PDF</th>
            <th class="text-center">
              <ColumnFilterMenu
                field="creado_en"
                label="Creación"
                :filterable="false"
                :items="disenos"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="(e) => $emit('update:sort', e)"
              />
            </th>
            <th class="text-center">
              <ColumnFilterMenu
                field="creado_por_nombre"
                label="Creado por"
                :filterable="false"
                :items="disenos"
                :sortField="sortKey"
                :sortAsc="sortDir === 'asc'"
                @update:sort="(e) => $emit('update:sort', e)"
              />
            </th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="d in disenos" :key="d.id">
            <td class="ps-4 fw-bold text-cafe">{{ d.cotizacion }}</td>

            <td>
              <div class="cliente-cell">
                <span class="cliente-num">{{ d.cliente_numero }}</span>
                <span>{{ d.cliente }}</span>
              </div>
            </td>

            <td class="text-center">
              <span :class="badgeEstatus(d.estatus)">{{ labelEstatus(d.estatus) }}</span>
            </td>

            <td class="text-center">
              <span :class="badgeWhatsapp(d.estatus_whatsapp)">
                <i class="bi bi-whatsapp me-1"></i>{{ labelWhatsapp(d.estatus_whatsapp) }}
              </span>
            </td>

            <td class="text-center">
              <button
                v-if="d.total_pdfs"
                class="btn-doc"
                title="Ver documentos"
                @click="$emit('ver-pdfs', d)"
              >
                <i class="bi bi-file-earmark-pdf-fill me-1"></i>Ver PDF
              </button>
              <span v-else class="text-cafe opacity-40 small">—</span>
            </td>

            <td class="text-center">{{ formatFecha(d.creado_en) }}</td>

            <td class="text-center">
              <span v-if="d.creado_por_nombre" class="autor-cell">
                <i class="bi bi-person-fill me-1"></i>{{ d.creado_por_nombre }}
              </span>
              <span v-else class="text-cafe opacity-40 small">—</span>
            </td>

            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <button
                  class="btn-circular"
                  title="Detalles"
                  @click="$emit('ver-detalle', d)"
                >
                  <i class="bi bi-list-ul"></i>
                </button>
                <button
                  class="btn-circular"
                  :disabled="!esEditable(d)"
                  :title="motivoBloqueo(d) || 'Editar'"
                  @click="$emit('editar', d)"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button
                  class="btn-circular text-danger"
                  :disabled="!esEditable(d)"
                  :title="motivoBloqueo(d) || 'Eliminar'"
                  @click="$emit('eliminar', d)"
                >
                  <i class="bi bi-trash3-fill"></i>
                </button>
              </div>
            </td>
          </tr>

          <tr v-if="disenos.length === 0 && !loading">
            <td colspan="8" class="text-center py-5 text-cafe opacity-50 fw-bold">
              No se encontraron registros
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginación escritorio -->
      <div class="paginacion-wrapper">
        <div class="pag-izq">
          <small class="pag-info">
            {{ rangoInicio }}–{{ rangoFin }} de {{ totalRegistros }} registros
          </small>
          <div class="por-pagina-wrap">
            <label class="por-pagina-label">Filas:</label>
            <select
              class="por-pagina-select"
              :value="porPagina"
              @change="$emit('cambiar-por-pagina', Number($event.target.value))"
            >
              <option v-for="n in opcionesPorPagina" :key="n" :value="n">{{ n }}</option>
            </select>
          </div>
        </div>

        <div class="pag-der">
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            title="Primera"
            @click="$emit('cambiar-pagina', 1)"
          >
            <i class="bi bi-chevron-double-left"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === 1"
            @click="$emit('cambiar-pagina', paginaActual - 1)"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <template v-for="(p, i) in paginasVisibles" :key="`${p}-${i}`">
            <span v-if="p === '...'" class="pag-ellipsis">…</span>
            <button
              v-else
              :class="['btn-pag-num', { activo: p === paginaActual }]"
              @click="$emit('cambiar-pagina', p)"
            >
              {{ p }}
            </button>
          </template>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            @click="$emit('cambiar-pagina', paginaActual + 1)"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
          <button
            class="btn-pag"
            :disabled="paginaActual === totalPaginas"
            title="Última"
            @click="$emit('cambiar-pagina', totalPaginas)"
          >
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- CARDS MÓVIL / TABLET -->
    <div class="d-xl-none">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-verde"></div>
      </div>

      <div
        v-else
        v-for="d in disenos"
        :key="'mob-' + d.id"
        class="divisan-mobile-card mb-3 p-3 shadow-sm"
      >
        <div class="d-flex justify-content-between align-items-start mb-1">
          <span class="fw-bold text-cafe card-name">{{ d.cotizacion }}</span>
          <span :class="badgeEstatus(d.estatus)">{{ labelEstatus(d.estatus) }}</span>
        </div>

        <div class="small text-muted-cafe mb-2">
          <span class="cliente-num me-1">{{ d.cliente_numero }}</span>{{ d.cliente }}
        </div>

        <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
          <span :class="badgeWhatsapp(d.estatus_whatsapp)">
            <i class="bi bi-whatsapp me-1"></i>{{ labelWhatsapp(d.estatus_whatsapp) }}
          </span>
          <small class="text-muted-cafe">{{ formatFecha(d.creado_en) }}</small>
          <span v-if="d.creado_por_nombre" class="autor-cell">
            <i class="bi bi-person-fill me-1"></i>{{ d.creado_por_nombre }}
          </span>
        </div>

        <div class="d-flex align-items-center gap-2 flex-wrap">
          <button v-if="d.total_pdfs" class="btn-doc" @click="$emit('ver-pdfs', d)">
            <i class="bi bi-file-earmark-pdf-fill me-1"></i>Ver PDF
          </button>
          <div class="ms-auto d-flex gap-2">
            <button class="btn-circular" title="Detalles" @click="$emit('ver-detalle', d)">
              <i class="bi bi-list-ul"></i>
            </button>
            <button
              class="btn-circular"
              :disabled="!esEditable(d)"
              :title="motivoBloqueo(d) || 'Editar'"
              @click="$emit('editar', d)"
            >
              <i class="bi bi-pencil-square"></i>
            </button>
            <button
              class="btn-circular text-danger"
              :disabled="!esEditable(d)"
              :title="motivoBloqueo(d) || 'Eliminar'"
              @click="$emit('eliminar', d)"
            >
              <i class="bi bi-trash3-fill"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="disenos.length === 0 && !loading"
        class="text-center py-5 text-cafe opacity-50 fw-bold"
      >
        No se encontraron registros
      </div>

      <!-- Paginación móvil -->
      <div v-if="totalPaginas > 1" class="paginacion-mobile d-flex justify-content-center gap-2">
        <button
          class="btn-pag"
          :disabled="paginaActual === 1"
          @click="$emit('cambiar-pagina', paginaActual - 1)"
        >
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="pag-info align-self-center">
          {{ paginaActual }} / {{ totalPaginas }}
        </span>
        <button
          class="btn-pag"
          :disabled="paginaActual === totalPaginas"
          @click="$emit('cambiar-pagina', paginaActual + 1)"
        >
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import ColumnFilterMenu from "@/components/Shared/ColumnFilterMenu.vue";

defineProps({
  disenos: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  paginaActual: { type: Number, default: 1 },
  totalPaginas: { type: Number, default: 1 },
  totalRegistros: { type: Number, default: 0 },
  rangoInicio: { type: Number, default: 0 },
  rangoFin: { type: Number, default: 0 },
  paginasVisibles: { type: Array, default: () => [] },
  sortKey: { type: String, default: "creado_en" },
  sortDir: { type: String, default: "desc" },
  porPagina: { type: Number, default: 10 },
  opcionesPorPagina: { type: Array, default: () => [10, 25, 50] },
});

defineEmits([
  "ver-pdfs",
  "ver-detalle",
  "editar",
  "eliminar",
  "cambiar-pagina",
  "update:sort",
  "cambiar-por-pagina",
]);

// ── Presentación de estatus ────────────────────────────────
const ESTATUS = {
  CREADO: { label: "Creado", clase: "estatus-creado" },
  EN_PROCESO: { label: "En proceso", clase: "estatus-proceso" },
  APROBADO: { label: "Aprobado", clase: "estatus-aprobado" },
  RECHAZADO: { label: "Rechazado", clase: "estatus-rechazado" },
};

const WHATSAPP = {
  NO_ENVIADO: { label: "No enviado", clase: "wa-no" },
  ENVIADO: { label: "Enviado", clase: "wa-enviado" },
  ENTREGADO: { label: "Entregado", clase: "wa-entregado" },
  LEIDO: { label: "Leído", clase: "wa-leido" },
  FALLIDO: { label: "Falló", clase: "wa-fallido" },
};

const labelEstatus = (v) => ESTATUS[v]?.label || v || "—";
const badgeEstatus = (v) => `badge-pill ${ESTATUS[v]?.clase || ""}`;
const labelWhatsapp = (v) => WHATSAPP[v]?.label || v || "—";
const badgeWhatsapp = (v) => `badge-pill ${WHATSAPP[v]?.clase || ""}`;

// Ya notificado = congelado: el cliente vio ese contenido y cambiarlo
// invalidaría la evidencia.
const esEditable = (d) => d.estatus_whatsapp === "NO_ENVIADO";
const motivoBloqueo = (d) =>
  esEditable(d) ? "" : "Ya se notificó al cliente; crea un registro nuevo";

function formatFecha(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
</script>

<style scoped>
.text-cafe {
  color: var(--d-brown);
}
.text-verde {
  color: var(--d-green);
}
.text-muted-cafe {
  color: var(--d-brown);
  opacity: 0.6;
}

/* ── Tabla ──────────────────────────────────────────────── */
.divisan-table-container {
  background-color: var(--d-cream);
  border-radius: var(--d-radius-lg);
  box-shadow: var(--d-elevation-2);
  overflow: hidden;
}
.table-divisan thead th {
  background: var(--d-cream);
  color: var(--d-brown);
  border-bottom: 1px solid var(--d-border);
}
.table-divisan th {
  padding: 15px;
  font-weight: 800;
  text-transform: capitalize;
  border: none;
  white-space: nowrap;
}
.table-divisan td {
  border-bottom: 1px solid rgba(96, 108, 56, 0.1);
  padding: 12px 15px;
}
.table-divisan tbody tr:hover td {
  background-color: rgba(96, 108, 56, 0.05);
}
.col-doc {
  width: 130px;
}

.cliente-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
  color: var(--d-brown);
}
.cliente-num {
  font-family: var(--d-font-mono);
  font-size: 0.72rem;
  color: var(--d-green);
  font-weight: 700;
}

/* Quién capturó la preaprobación: sirve para saber a quién preguntarle */
.autor-cell {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--d-brown);
  white-space: nowrap;
}

/* ── Badges ─────────────────────────────────────────────── */
.badge-pill {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 20px;
  padding: 2px 10px;
  white-space: nowrap;
}
.estatus-creado,
.wa-no {
  background: rgba(64, 34, 8, 0.1);
  color: #6d4c41;
}
.estatus-proceso,
.wa-enviado {
  background: #e3f2fd;
  color: #1565c0;
}
.estatus-aprobado,
.wa-entregado,
.wa-leido {
  background: #e8f5e9;
  color: #1b5e20;
}
.estatus-rechazado {
  background: #fdeaea;
  color: #c62828;
}
.wa-fallido {
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

/* ── Botón Ver PDF (mismo de TPUs) ──────────────────────── */
.btn-doc {
  display: inline-flex;
  align-items: center;
  background: rgba(220, 53, 69, 0.08);
  color: #dc3545;
  border: 1px solid rgba(220, 53, 69, 0.25);
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 0.78rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.15s;
  white-space: nowrap;
  cursor: pointer;
}
.btn-doc:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

/* ── Acciones ───────────────────────────────────────────── */
.btn-circular {
  background: white;
  border: 1px solid var(--d-green);
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--d-green);
  transition: 0.2s;
}
.btn-circular:hover:not(:disabled) {
  background-color: var(--d-green);
  color: var(--d-cream);
}
.btn-circular:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.btn-circular.text-danger {
  border-color: rgba(220, 53, 69, 0.5);
}
.btn-circular.text-danger:hover:not(:disabled) {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white !important;
}

/* ── Cards móvil ────────────────────────────────────────── */
.divisan-mobile-card {
  background-color: var(--d-cream);
  border-radius: 15px;
  border-left: 6px solid var(--d-green);
}
.card-name {
  font-size: 1rem;
}

/* ── Paginación ─────────────────────────────────────────── */
.paginacion-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  flex-wrap: wrap;
  gap: 8px;
  border-top: 1px solid rgba(64, 34, 8, 0.1);
  background: rgba(96, 108, 56, 0.05);
}
.pag-izq {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.pag-der {
  display: flex;
  align-items: center;
  gap: 4px;
}
.pag-info {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.por-pagina-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  white-space: nowrap;
}
.por-pagina-select {
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23606c38' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 8px center;
  border: 1.5px solid var(--d-green);
  border-radius: 8px;
  padding: 3px 26px 3px 10px;
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--d-brown);
  cursor: pointer;
  outline: none;
  min-width: 58px;
}
.por-pagina-select:focus,
.por-pagina-select:hover {
  border-color: var(--d-brown);
}
.btn-pag {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.35);
  color: var(--d-brown);
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.8rem;
}
.btn-pag:hover:not(:disabled) {
  background: var(--d-green);
  color: var(--d-cream);
  border-color: var(--d-green);
}
.btn-pag:disabled {
  opacity: 0.3;
  cursor: default;
}
.btn-pag-num {
  background: white;
  border: 1.5px solid rgba(96, 108, 56, 0.25);
  color: var(--d-brown);
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.18s;
  font-size: 0.82rem;
  font-weight: 700;
}
.btn-pag-num:hover {
  background: rgba(96, 108, 56, 0.1);
  border-color: var(--d-green);
}
.btn-pag-num.activo {
  background: var(--d-brown);
  color: var(--d-cream);
  border-color: var(--d-brown);
  pointer-events: none;
}
.pag-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 32px;
  font-size: 0.85rem;
  color: var(--d-brown);
  opacity: 0.4;
  font-weight: 700;
}
.paginacion-mobile {
  border-top: 1px solid rgba(64, 34, 8, 0.15);
  padding: 10px 4px;
  margin-top: 4px;
}
</style>
